/**
 * 功能: 厂牌列表显示，厂牌的数据新增、修改，删除数据
 */

<template lang="pug">
  .content
    div
      el-form(:inline="true" :model="findTeam")
        el-form-item.fl(label="")
          //- el-input(v-model="findTeam.fullSearch" placeholder="请输入搜索内容" :size="GLOBAL.SIZE_OF_INPUTBOX")
          el-input(placeholder="请输入搜索内容" v-model="findTeam.fullSearch" style="width: 300px" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable)
            el-button(slot="append" icon="el-icon-search" @click="clickSearchButton()")
        el-form-item.fl
        el-form-item.fr
          el-button(type="primary" @click="clickAdd()" :size="GLOBAL.SIZE_OF_INPUTBOX") 添加
      el-col(:span="20")
      el-table(:data="teamData" stripe style="width: 100%" @sort-change='teamSortChange' id="team" v-loading="loading")
        el-table-column(prop="avatar" label="头像"  width="60" align="center")
          template(slot-scope="scope")
            el-avatar(v-if="scope.row.avatar===undefined" icon="el-icon-user-solid")
            el-avatar(v-else :src="GLOBAL.OSS+scope.row.avatar" )
        el-table-column(prop="name" label="厂牌名称" sortable="custom" width="180")
        el-table-column(prop="relative" label="报告数量" width="100" align="center" sortable="custom")
        el-table-column(prop="phone" label="对外电话" width="125" align="center")
        el-table-column(prop="url" label="网址" width="180" align="center" show-overflow-tooltip)
        el-table-column(prop="member" label="成员" show-overflow-tooltip)
          template(slot-scope="scope")
            span(v-if="scope.row.memberIds.length === 0") 暂无成员
            span(v-for="member in scope.row.memberIds") {{ member.name+' ' }}
        el-table-column(prop="description" label="描述" show-overflow-tooltip)
          template(slot-scope="scope")
            span(v-if="scope.row.description" v-html="scope.row.description")

        el-table-column(label="操作" width= "150")
          template(slot-scope="scope")
            el-button-group
              el-button( title = "修改" icon="el-icon-edit" round type="info" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="updateTeam(scope.$index,scope.row)" )
              el-button( title = "删除" type="danger" icon="el-icon-delete" round
                :size="GLOBAL.SIZE_OF_INPUTBOX" @click="deleteTeam(scope.row)")
      div.fr
        el-pagination(
            background
            @current-change="handleCurrentChange"
            :current-page.sync="findTeam.currentPage"
            layout="total,prev, pager, next, jumper"
            :page-size="findTeam.pageSize"
            :total="totalPage")
    Dialog(ref="dialog" :teamInfo="addTeam" @saveTeam="saveTeam")
</template>

<script>
import Dialog from './components/teamDialog'
import Team from '@/apis/team'

export default {
  components: {
    Dialog
  },
  data () {
    return {
      findTeam: {
        fullSearch: '',
        currentPage: 1,
        pageSize: 15,
        sortwhere: { order: 'descending', prop: 'createdAt' }
      },
      totalPage: 0,
      addTeam: { },
      teamData: [],

      loading: false
    }
  },
  created () {
    this.getTeam()
  },
  methods: {
    // 对厂牌进行排序
    teamSortChange (column) {
      const { order, prop } = column
      this.findTeam.sortwhere = { order, prop }
      this.getTeam()
    },
    // 搜索
    clickSearchButton () {
      this.findTeam.currentPage = 1
      this.getTeam()
    },
    // 获取厂牌分页
    getTeam () { // 获取厂牌
      this.loading = true
      Team.getTeamPage(this.findTeam).then(r => {
        this.totalPage = r.data.count
        this.teamData = r.data.data
        this.loading = false
      })
    },
    // 保存厂牌
    saveTeam (team, cb) {
      if (team._id === '' || team._id === undefined) {
        delete team._id
        Team.addNewTeam(team).then(r => {
          this.$message({
            type: 'success',
            message: '已添加'
          })
          this.findTeam.currentPage = 1
          this.getTeam()
        })
        cb && cb()
      } else {
        Team.updateTeam(team).then(r => {
          this.$message({
            type: 'success',
            message: '已修改'
          })
          this.getTeam()
        })
        cb && cb()
      }
    },
    // 分页
    handleCurrentChange (val) {
      this.findTeam.currentPage = val
      this.getTeam()
    },
    // 点击新建 显示dialog组件
    clickAdd () {
      this.addTeam = {}
      this.$refs.dialog.imageUrl = ''
      this.$refs.dialog.memberTags = []
      this.$refs.dialog.isShowTeamDialog()
    },
    // 点击修改 显示dialog组件
    updateTeam (index, row) {
      this.addTeam = row
      this.$refs.dialog.imageUrl = row.avatar
      this.$refs.dialog.memberTags = row.memberIds
      this.$refs.dialog.isShowTeamDialog()
    },
    // 删除厂牌
    deleteTeam (row) {
      const data = {
        id: row._id
      }
      this.$confirm('此操作将删除该厂牌, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Team.deleteTeam(data).then(r => {
          if (r) {
            this.$message({
              message: '已删除',
              type: 'success'
            })
            this.getTeam()
          }
        }).catch(err => {
          this.$message({
            message: '删除失败,' + err.msg,
            type: 'error'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}

</script>
<style scoped>
.inline-input{
  width: 300px
}
.content{
  padding:0
}

</style>

<style>
#team .el-avatar>img{margin: 0 auto; width: 100%; height: 100%;}
</style>
